export const GROUP_MOVEMENTS = `
  query groupMovements(
    $tenant_id: Int!
    $skip: Int
    $take: Int
    $orderBy: GroupMovementOrderInput
    $filter: FilterGroupMovementInput
    $searchText: String
  ) {
    groupMovements(
      tenant_id: $tenant_id
      skip: $skip
      take: $take
      orderBy: $orderBy
      filter: $filter
      searchText: $searchText
    ) {
      __typename
      ... on GroupMovement {
        id
        group_id
        group {
          id
          name
        }
        member_id
        member {
          id
          contact {
            id
            firstname
            lastname
          }
        }
        request_reason_id
        request_reason {
          id
          name
          translation_key
        }
        request_id
        request {
          id
          data
        }
        amount
        percentage
        description
        reversed
        applied_from
        applied_until
        data
        created_by
        its
        uts
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const GROUP_MOVEMENT_COUNT = `
  query groupMovementCount(
    $tenant_id: Int!
    $filter: FilterGroupMovementInput
    $searchText: String
  ) {
    groupMovementCount(
      tenant_id: $tenant_id
      filter: $filter
      searchText: $searchText
    ) {
      __typename
      ... on Count {
        count
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;
